import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UploadDto } from '@hub/generated/models';
import {
  ArrayBufferRequestOptionsArgs,
  BaseRequestOptionsArgs,
} from '@hub/models/ClientRequestOptionsArgs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpClientService {
  constructor(private http: HttpClient) {
  }

  public post<T>(
    url: string,
    data: any,
    options?: BaseRequestOptionsArgs,
  ): Observable<T> {
    return this.http.post<T>(url, data, options);
  }

  public get<T>(
    url: string,
    params?: any,
    options?: BaseRequestOptionsArgs,
  ): Observable<T> {
    options = this.addParamsToOptions(params, options);
    return this.http.get<T>(url, options);
  }

  public delete<T>(
    url: string,
    params?: any,
    options?: BaseRequestOptionsArgs,
  ): Observable<T> {
    options = this.addParamsToOptions(params, options);
    return this.http.delete<T>(url, options);
  }

  public postArrayBuffer(
    url: string,
    data: any,
    options?: BaseRequestOptionsArgs,
  ): Observable<ArrayBuffer> {
    const requestOptions = {
      ...options,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.post(url, data, requestOptions);
  }

  public postOnlyResponse<T>(
    url: string,
    data: any,
    options?: BaseRequestOptionsArgs,
  ): Observable<any> {
    const requestOptions = {
      ...options,
      observe: 'response' as 'response',
      responseType: 'blob' as 'blob',
    };

    return this.http.post(url, data, requestOptions);
  }

  public postWithFile(
    url: string,
    file: File,
    data?: any,
    options?: BaseRequestOptionsArgs,
  ): Observable<UploadDto> {
    options = this.addParamsToOptions(data, options);

    const formData: FormData = new FormData();
    if (file != null) {
      formData.append('postedFile', file, file.name);
    }
    if (data != null) {
      formData.append('dto', JSON.stringify(data));
    }
    return this.http.post<UploadDto>(url, formData, options);

  }

  private addParamsToOptions(
    params: any,
    options: BaseRequestOptionsArgs
  ): BaseRequestOptionsArgs {
    if (!!params) {
      let searchParams: HttpParams = new HttpParams();
      const keys = Object.keys(params);
      const keysCount = keys.length;
      for (let i = 0; i < keysCount; i++) {
        const key = keys[i];
        const value = params[key];
        searchParams = searchParams.append(key, value);
      }

      if (!options) {
        options = new BaseRequestOptionsArgs();
      }

      options.params = searchParams;
    }


    return options;
  }
}
